import { Observable } from "rxjs";

export default class MapElement {

    constructor(id, hidden) {
        this.id = id;
        this.selected = false;
        this.highlighted = false;
        this.interactive = true;
        this.hidden = hidden;
        this.masterMapElement = null;

        this.normalStyle = null;
        this.selectedStyle = null;
        this.statusVisibleStyle = null;

        this.children = [];
    }

    getId() {
        return this.id;
    }

    getName() {
        throw new Error("method must be overriden by subclasses");
    }

    getSummary() {
        throw new Error("method must be overriden by subclasses");
    }

    getDescription() {
        throw new Error("method must be overriden by subclasses");
    }

    getObservation() {
        throw new Error("method must be overriden by subclasses");
    }

    getPlaceInformation() {
        throw new Error("method must be overriden by subclasses");
    }

    getTrailInformation() {
        throw new Error("method must be overriden by subclasses");
    }

    getType() {
        throw new Error("method must be overriden by subclasses");
    }

    getIconFileName() {
        throw new Error("method must be overriden by subclasses");
    }

    getIconUrl() {
        throw new Error("method must be overriden by subclasses");
    }

    isHideable() {
        throw new Error("method must be overriden by subclasses");
    }

    isHidden() {
        return this.hidden;
    }

    getSections() {
        throw new Error("method bust be overriden by subclasses");
    }

    setHidden(hidden) {
        if (hidden != this.hidden) {
            this.hidden = hidden;

            if (this.subscriber) {
                this.subscriber.next({
                    field: "hidden",
                    value: this.hidden
                });
            }

            for (var child of this.children) {
                child.setHidden(hidden);
            }
        }
    }

    isSelected() {
        return this.selected;
    }

    setSelected(selected) {
        if (selected != this.selected) {
            this.selected = selected;

            if (this.subscriber) {
                this.subscriber.next({
                    field: "selected",
                    value: this.selected
                });
            }

            if (this.isHidden()) {
                this.setHidden(false);
            }
        }
    }

    isHighlighted() {
        return this.highlighted;
    }

    setHighlighted(highlighted) {
        if (highlighted != this.highlighted) {
            this.highlighted = highlighted;

            if (this.subscriber) {
                this.subscriber.next({
                    field: "highlighted",
                    value: this.highlighted
                });
            }
        }
    }

    isInteractive() {
        return this.interactive;
    }

    setInteractive(interactive) {
        this.interactive = interactive;
    }

    getLocation() {
        throw new Error("method must be overriden by subclasses.");
    }

    getChildren() {
        return this.children;
    }

    getStyle() {
        if (this.isSelected() && this.selectedStyle != null) {
            return this.selectedStyle;
        } else {
            return this.normalStyle;
        }
    }

    getTags() {
        throw new Error("method must be overrided by subclasses.");
    }

    observe() {
        this.observable = new Observable((subscriber) => {
            this.subscriber = subscriber;
        });
        return this.observable;
    }

    /* eslint-disable no-unused-vars */
    toGeoJSONFeature(baseOSMZoom, projectionProxy) {
        throw new Error("Method must be overriden by subclasses.");
    }
    /* eslint-enable no-unused-vars */

    _zoomStopProperty(zoomStop, propertyName) {
		const roundedZoomStop = Math.ceil(zoomStop * 100.0);
		var property = "stop_" + roundedZoomStop + "_";
		property = property.replace(",", ".").replace(".", "_");
		return property + propertyName;
	}
}